import { CodeType } from '../api-client/api-types'

import { getItemByKeyValue } from '../helpers/index'
import { saveUserData, getUserData } from '../local-client/local-client'

interface StoredCodeStats {
  status: CodeType[]
  metricValues: MetricSource[]
  codeIDs: string[]
}

interface CurrentUser {
  acceptedMarketing: 'true' | 'false'
  currentAccountPermission: PermissionLevel
  email: string
  firstName: string
  lastName: string
  preferredHomepage: string
  profileImgLink: string
  publicJobTitle: string
  telNum: string
  userAccountProfiles: AccountInfo[]
  userID: string
  userName: string
}

interface CurrentAccount {
  accountID: string
  accountName: string
  blankAccount: boolean
  companyID: string
  companyName: string
  created: string
  explainAvailable: boolean
  trackAvailable: boolean
  auditAvailable: boolean
  reportAvailable: boolean
  homepage: string
  logoLink: string
  isDemo: boolean
  uplifterAccountLandingPage: string
  dataSource: {
    kind: string
    connected: boolean
  }
  qrSettings: {
    name: string
    enabled: boolean
    value: string
  }[]
  qrCodeLogoList: string[]
  qrCodeLogoSrc: string
  userAccountProfiles: AccountInfo[]
}

export interface GraphQLState {
  currentUser: CurrentUser | null
  currentAccount: CurrentAccount | null
  campaignLinkDashboardMetricData: any
  campaignLinkDashboardMetricDataClickData: any
  campaignLinkDashboardGraph: any
  campaignLinkDashboardGraphClickData: any
  campaignLinkDashboardTable: any
  campaignLinkDashboardTableRows: any
  campaignLinkDashboardMeta: any
  campaignCodeGenerator: any
  storedCodeStats: StoredCodeStats
  dataSourceMetricList: any
  shortLinkCandidates: any
  validateShortLinkCandidate: {
    availableUntil: string
    isAvailable: boolean
    shortLinkID: string
  }[]
  error: string[]
  loading: string[]
  enterpriseBillingDetail: EnterpriseBillingDetails | null
  listSavedLinkPerformanceReports: {
    hiddenReportList: any[]
    savedReports: any[]
    userPreferredOrder: string[]
  }
}

export const initialState = {
  campaignCodeGenerator: null,
  currentUser: null,
  currentAccount: null,
  campaignLinkDashboardMetricData: null,
  campaignLinkDashboardMetricDataClickData: null,
  campaignLinkDashboardGraph: null,
  campaignLinkDashboardGraphClickData: null,
  campaignLinkDashboardTable: null,
  campaignLinkDashboardTableRows: null,
  campaignLinkDashboardMeta: null,
  storedCodeStats: { status: [], codeIDs: [], metricValues: [] },
  dataSourceMetricList: null,
  shortLinkCandidates: null,
  validateShortLinkCandidate: [],
  error: [],
  loading: [],
  enterpriseBillingDetail: null,
  listSavedLinkPerformanceReports: {
    hiddenReportList: [],
    savedReports: [],
    userPreferredOrder: [],
  },
}
export const keys = [
  'currentUser',
  'currentAccount',
  'campaignLinkDashboardMetricData',
  'campaignLinkDashboardMetricDataClickData',
  'campaignLinkDashboardGraph',
  'campaignLinkDashboardGraphClickData',
  'campaignLinkDashboardTable',
  'campaignLinkDashboardTableRows',
  'campaignLinkDashboardMeta',
  'storedCodeStats',
  'dataSourceMetricList',
  'shortLinkCandidates',
  'validateShortLinkCandidate',
  'enterpriseBillingDetail',
  'listSavedLinkPerformanceReports',
]
export const graphql = (
  state: GraphQLState = initialState,
  action: ReduxAction,
): GraphQLState => {
  switch (action.type) {
    case 'UPDATE_REPORT_GRAPHQL_DATA': {
      const { report } = action.payload
      const {
        hiddenReportList,
        savedReports,
        userPreferredOrder,
      } = state.listSavedLinkPerformanceReports
      let newUserPreferredOrder = [...userPreferredOrder]
      let newSaveReports = [...savedReports]
      const found = getItemByKeyValue(
        savedReports,
        'savedReportID',
        report.savedReportID,
      )
      if (found === -1) {
        newSaveReports = [...savedReports, report]
        newUserPreferredOrder = [...userPreferredOrder, report.savedReportID]
      } else {
        newSaveReports = savedReports.map((item) => {
          if (item.savedReportID === report.savedReportID) {
            return {
              ...report,
            }
          }
          return {
            ...item,
          }
        })
      }
      return {
        ...state,
        listSavedLinkPerformanceReports: {
          hiddenReportList,
          savedReports: newSaveReports,
          userPreferredOrder: newUserPreferredOrder,
        },
      }
    }
    case 'VALIDATE_SHORT_LINK_GRAPHQL_DATA': {
      // eslint-disable-next-line
      // debugger
      const { validateShortLinkCandidate } = state
      action.payload.validateShortLinkCandidate.forEach((candidate) => {
        const { shortLinkID } = candidate
        const found = getItemByKeyValue(
          validateShortLinkCandidate,
          'shortLinkID',
          shortLinkID,
          true,
        )
        if (found !== -1) {
          validateShortLinkCandidate[found] = {
            ...candidate,
          }
        } else {
          validateShortLinkCandidate.push({
            ...candidate,
          })
        }
      })

      saveUserData([...validateShortLinkCandidate], 'upl.inc')

      return {
        ...state,
        ...validateShortLinkCandidate,
      }
    }
    case 'REMOVE_SHORT_LINK_GRAPHQL_DATA': {
      // eslint-disable-next-line
      // debugger
      const useLinksCandidates = state.validateShortLinkCandidate.filter(
        ({ shortLinkID }) => {
          return action.payload.indexOf(shortLinkID) === -1
        },
      )

      return {
        ...state,
        validateShortLinkCandidate: useLinksCandidates,
      }
    }

    case 'INVALIDATE_SHORT_LINK_GRAPHQL_DATA': {
      // eslint-disable-next-line
      // debugger
      const useLinksCandidates = state.validateShortLinkCandidate.filter(
        ({ shortLinkID }) => {
          return action.payload.indexOf(shortLinkID) === -1
        },
      )

      const savedData = getUserData('upl.inc')

      if (savedData && Array.isArray(savedData) && action.payload.length > 0) {
        const useSavedData = savedData.filter(({ shortLinkID }) => {
          return action.payload.indexOf(shortLinkID) === -1
        })
        saveUserData([...useSavedData], 'upl.inc', false)
      }

      return {
        ...state,
        validateShortLinkCandidate: useLinksCandidates,
      }
    }
    case 'UPDATE_GRAPHQL_SAVED_REPORTS_DATA': {
      // eslint-disable-next-line
      // debugger
      const { userPreferredOrder } = action.payload
      const { listSavedLinkPerformanceReports } = state
      return {
        ...state,
        listSavedLinkPerformanceReports: {
          ...listSavedLinkPerformanceReports,
          userPreferredOrder: [...userPreferredOrder],
        },
      }
    }
    case 'UPDATE_GRAPHQL_DATA': {
      // eslint-disable-next-line
      // debugger
      const newState = {}
      const erroredKeys = [...state.error]
      const loadingKeys = [...state.loading]
      keys.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(action.payload, key)) {
          newState[key] = { ...state[key], ...action.payload[key] }
          const pos = erroredKeys.indexOf(key)
          if (pos !== -1) {
            erroredKeys.splice(pos, 1)
          }
          const posLoading = loadingKeys.indexOf(key)
          if (posLoading !== -1) {
            loadingKeys.splice(posLoading, 1)
          }
        }
      })
      return {
        ...state,
        ...newState,
        error: [...erroredKeys],
        loading: [...loadingKeys],
      }
    }
    case 'START_LOADING_GRAPHQL_DATA': {
      const { loading } = action.payload
      const loadingKeys = [...state.loading]
      if (loading) {
        loading.forEach((key) => {
          // keys can be added multiple times
          // this is important for multiple loads

          // if (loadingKeys.indexOf(key) === -1) {
          loadingKeys.push(key)
          // }
        })
      }
      return {
        ...state,
        loading: [...loadingKeys],
      }
    }
    case 'CLEAR_ERROR_GRAPHQL_DATA': {
      const { error } = action.payload
      const erroredKeys = [...state.error]
      if (error) {
        error.forEach((key) => {
          const pos = erroredKeys.indexOf(key)
          if (pos !== -1) {
            erroredKeys.splice(pos, 1)
          }
        })
      }
      return {
        ...state,
        error: [...erroredKeys],
      }
    }
    case 'ERROR_GRAPHQL_DATA': {
      const { error } = action.payload
      const erroredData = {}
      const erroredKeys = [...state.error]
      const loadingKeys = [...state.loading]
      if (error) {
        error.forEach((key) => {
          erroredData[key] = Object.prototype.hasOwnProperty.call(
            initialState,
            key,
          )
            ? initialState[key]
            : null
          if (erroredKeys.indexOf(key) === -1) {
            erroredKeys.push(key)
          }
          const posLoading = loadingKeys.indexOf(key)
          if (posLoading !== -1) {
            loadingKeys.splice(posLoading, 1)
          }
        })
      }
      return {
        ...state,
        ...erroredData,
        error: [...erroredKeys],
        loading: [...loadingKeys],
      }
    }
    case 'UPDATE_PREFERRED_HOMEPAGE': {
      const newState = JSON.parse(JSON.stringify(state))

      if (newState.currentUser) {
        newState.currentUser = {
          ...newState.currentUser,
          preferredHomepage: action.payload.currentUser.preferredHomepage,
        }
      } else {
        newState.currentUser = {
          preferredHomepage: action.payload.currentUser.preferredHomepage,
        }
      }

      if (action.payload.currentAccount) {
        if (newState.currentAccount) {
          newState.currentAccount = {
            ...newState.currentAccount,
            auditAvailable: action.payload.currentAccount.auditAvailable,
            explainAvailable: action.payload.currentAccount.explainAvailable,
            reportAvailable: action.payload.currentAccount.reportAvailable,
            trackAvailable: action.payload.currentAccount.trackAvailable,
          }
        } else {
          newState.currentAccount = {
            auditAvailable: action.payload.currentAccount.auditAvailable,
            explainAvailable: action.payload.currentAccount.explainAvailable,
            reportAvailable: action.payload.currentAccount.reportAvailable,
            trackAvailable: action.payload.currentAccount.trackAvailable,
          }
        }
      }
      return newState
    }
    default:
      return state
  }
}
